import type { PreOrder, PreOrderFlow } from "@/app/api/types/preOrder";
import type {
  ProposalBatch,
  Proposal,
} from "@stockline/shared/types/ai/proposal";

export interface ProposalAnnotation {
  batchId: string;
  operation: "create" | "update" | "delete";
  batch: ProposalBatch;
  proposals: Proposal[];
  /** Proposal record that produced this annotation — used to route edits */
  sourceProposalId?: string;
}

export interface FlowProposalDiff {
  oldValue?: string;
  newValue?: string;
}

export interface FlowProposalAnnotation {
  operation: "create" | "update" | "delete";
  fieldDiffs: Record<string, FlowProposalDiff>;
  /** Proposal record that produced this annotation — used to route edits */
  sourceProposalId?: string;
}

export type ProposalPreOrder = PreOrder & {
  __proposal: ProposalAnnotation;
};

export type ProposalFlow = PreOrderFlow & {
  __proposalDiff?: FlowProposalAnnotation;
};

export function isProposalPreOrder(po: PreOrder): po is ProposalPreOrder {
  return "__proposal" in po && (po as ProposalPreOrder).__proposal != null;
}

export function isProposalFlow(flow: PreOrderFlow): flow is ProposalFlow {
  return (
    "__proposalDiff" in flow && (flow as ProposalFlow).__proposalDiff != null
  );
}
